import { batch } from 'react-redux';

import { handleErrors } from './ErrorActions';
import * as taskStatusApi from '../api/task-status';

export const GET_TASK_COUNT_BY_STATUS = 'TaskCountByStatus/GET_TASK_COUNT_BY_STATUS';
export const GET_TASK_COUNT_BY_STATUS_SUCCESS =
  'TaskCountByStatus/GET_TASK_COUNT_BY_STATUS_SUCCESS';
export const GET_TASK_COUNT_BY_STATUS_FAILURE =
  'TaskCountByStatus/GET_TASK_COUNT_BY_STATUS_FAILURE';

export const getTaskCountByStatusSuccess = (data) => ({
  type: GET_TASK_COUNT_BY_STATUS_SUCCESS,
  payload: {
    data,
  },
});

export const getTaskCountByStatusFailure = (error) => ({
  type: GET_TASK_COUNT_BY_STATUS_FAILURE,
  payload: {
    error,
  },
});

export const getTaskCountByStatus = (params) => async (dispatch) => {
  dispatch({
    type: GET_TASK_COUNT_BY_STATUS,
  });

  try {
    const apiData = await taskStatusApi.getTaskCountByStatus(params);

    if (apiData.hasError) {
      dispatch(getTaskCountByStatusFailure(apiData.errors));
      dispatch(handleErrors(apiData.errors));
      return;
    }

    dispatch(getTaskCountByStatusSuccess(apiData.taskByStatus));
  } catch (error) {
    batch(() => {
      dispatch(getTaskCountByStatusFailure(error));
      dispatch(handleErrors(error));
    });
  }
};
